//menu Perfil do Visitante
export const defaultComponents = [
    { id: 1, field: 'Gênero', component: 'genderQuestions', enabled: true },
    {
        id: 2,
        field: 'Tempo médio de estadia',
        component: 'averageLengthOfStayQuestions',
        enabled: true,
    },
    {
        id: 3,
        field: 'Preferência de acomodação',
        component: 'accommodationPreferencesQuestion',
        enabled: true,
    },
    { id: 4, field: 'Origem', component: 'stateOriginQuestion', enabled: true },
    {
        id: 5,
        field: 'Preferência de modal',
        component: 'transportModePreferencesQuestion',
        enabled: true,
    },
    {
        id: 6,
        field: 'Atrações favoritas',
        component: 'favoriteAttractions',
        enabled: true,
    },
    {
        id: 7,
        field: 'Idade Média',
        component: 'ageRangeQuestion',
        enabled: true,
    },
]
export const defaultToPrint = [
    { id: 1, field: 'Gênero', component: 'genderQuestions', print: true },
    {
        id: 2,
        field: 'Tempo médio de estadia',
        component: 'averageLengthOfStayQuestions',
        print: true,
    },
    {
        id: 3,
        field: 'Preferência de acomodação',
        component: 'accommodationPreferencesQuestion',
        print: true,
    },
    { id: 4, field: 'Origem', component: 'stateOriginQuestion', print: true },
    {
        id: 5,
        field: 'Preferência de modal',
        component: 'transportModePreferencesQuestion',
        print: true,
    },
    {
        id: 6,
        field: 'Atrações favoritas',
        component: 'favoriteAttractions',
        print: true,
    },
    {
        id: 7,
        field: 'Idade Média',
        component: 'ageRangeQuestion',
        print: true,
    },
]

// //menu Desempenho economico
export const defaultEconomicPerformanceComponents = [
    { id: 1, field: 'Gasto médio do visitante', component: 'AverageVisitorSpend', enabled: true },
    { id: 2, field: 'Desempenho dos modais', component: 'TransportPerformance', enabled: true },
    {
        id: 4,
        field: 'Ocupação Hoteleira e Fluxo Turistico',
        component: 'HotelOccupancyAndTouristFlow',
        enabled: true,
    },
    { id: 5, field: 'Ocupação Hoteleira', component: 'HotelOccupancy', enabled: true },
    {
        id: 6,
        field: 'Avaliações',
        component: 'Reviews',
        enabled: true,
    },
    {
        id: 7,
        field: 'Sentimento',
        component: 'Reviews',
        enabled: true,
    },
    {
        id: 8,
        field: 'Palavras-chave em alta em avaliações',
        component: 'Keywords',
        enabled: true,
    },
    {
        id: 9,
        field: 'Eventos',
        component: 'Event',
        enabled: true,
    },
    {
        id: 10,
        field: 'Visão Geral do Câmbio',
        component: 'Exchange',
        enabled: true,
    },
]
export const defaultEconomicPerformanceToPrint = [
    { id: 1, field: 'Gasto médio do visitante', component: 'AverageVisitorSpend', print: true },
    { id: 2, field: 'Desempenho dos modais', component: 'TransportPerformance', enabled: true },
    {
        id: 4,
        field: 'Ocupação Hoteleira e Fluxo Turistico',
        component: 'HotelOccupancyAndTouristFlow',
        print: true,
    },
    { id: 5, field: 'Ocupação Hoteleira', component: 'HotelOccupancy', print: true },
    {
        id: 6,
        field: 'Avaliações',
        component: 'Reviews',
        print: true,
    },
    {
        id: 7,
        field: 'Sentimento',
        component: 'Reviews',
        print: true,
    },
    {
        id: 8,
        field: 'Palavras-chave em alta em avaliações',
        component: 'Keywords',
        print: true,
    },
    {
        id: 9,
        field: 'Eventos',
        component: 'Event',
        print: true,
    },
    {
        id: 10,
        field: 'Visão Geral do Câmbio',
        component: 'Exchange',
        print: true,
    },
]
